























import { Component, Vue, Prop } from 'vue-property-decorator'

import _ from 'lodash'
import UserModel from '@/_models/UserModel'

@Component({
  components: {},
})
export default class NaviUsersAlertModal extends Vue {
  @Prop()
  users!: UserModel[]

  isOpenModelNaviAlert = false

  get hasAlertUsers(): UserModel[] {
    const users = this.users?.filter((user) => !!user.error_message)
    this.isOpenModelNaviAlert = !!users.length
    return users
  }
}
